import React from "react";
import { TextField } from "@mui/material";

const CakeBasicInfoForm = ({ formData, onChange }) => (
  <>
    <TextField
      label="Internal Name"
      name="name"
      fullWidth
      margin="dense"
      value={formData.name}
      onChange={onChange}
    />
    <TextField
      label="Display Name"
      name="displayName"
      fullWidth
      margin="dense"
      value={formData.displayName}
      onChange={onChange}
    />
    <TextField
      label="Description"
      name="description"
      fullWidth
      margin="dense"
      multiline
      rows={3}
      value={formData.description}
      onChange={onChange}
    />
    <TextField
      label="Base Price"
      name="basePrice"
      fullWidth
      margin="dense"
      value={formData.basePrice}
      onChange={onChange}
    />
    <TextField
      label="Searchable Description"
      name="searchableDescription"
      fullWidth
      margin="dense"
      value={formData.searchableDescription}
      onChange={onChange}
    />
  </>
);

export default CakeBasicInfoForm;
